import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connectShopifyToExistingAccount } from '../services/auth';

const ConnectShopify = () => {
  const [shopDomain, setShopDomain] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setSuccess(false);

    try {
      if (!shopDomain) {
        throw new Error('Veuillez entrer le domaine de votre boutique Shopify');
      }

      // Nettoyer et formater l'URL de la boutique
      let cleanShopDomain = shopDomain.trim();
      
      // Supprimer les préfixes http:// ou https:// et les slashes à la fin
      cleanShopDomain = cleanShopDomain.replace(/^https?:\/\//, '').replace(/\/$/, '');
      
      // Ajouter .myshopify.com si nécessaire
      if (!cleanShopDomain.includes('.myshopify.com')) {
        cleanShopDomain = `${cleanShopDomain}.myshopify.com`;
      }
      
      console.log('URL de boutique formatée:', cleanShopDomain);

      const result = await connectShopifyToExistingAccount(cleanShopDomain);
      console.log('Boutique Shopify connectée avec succès:', result);
      
      if (result && result.shopifyUrl) {
        setSuccess(true);
        setRedirectUrl(result.shopifyUrl);
        // Redirection automatique après 3 secondes
        setTimeout(() => {
          window.location.href = result.shopifyUrl;
        }, 3000);
      } else {
        throw new Error('URL de redirection Shopify non disponible');
      }
    } catch (error) {
      console.error('Erreur lors de la connexion de la boutique Shopify:', error);
      setError(error.message || 'Une erreur est survenue lors de la connexion de la boutique Shopify');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Connecter une boutique Shopify</h1>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          <p>{error}</p>
        </div>
      )}
      
      {success ? (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
          <p>Votre boutique a été connectée avec succès!</p>
          <p>Vous allez être redirigé vers Shopify pour autoriser l'application...</p>
          <p className="mt-2">
            <a 
              href={redirectUrl} 
              className="text-blue-500 underline"
              target="_blank" 
              rel="noopener noreferrer"
            >
              Cliquez ici si vous n'êtes pas redirigé automatiquement
            </a>
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="shopDomain">
              Domaine de votre boutique Shopify
            </label>
            <input
              id="shopDomain"
              type="text"
              placeholder="votre-boutique.myshopify.com"
              value={shopDomain}
              onChange={(e) => setShopDomain(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              disabled={loading}
              required
            />
            <p className="text-gray-600 text-xs italic mt-1">
              Entrez l'URL complète de votre boutique Shopify (ex: https://votre-boutique.myshopify.com)
            </p>
          </div>
          
          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              disabled={loading}
            >
              {loading ? 'Connexion en cours...' : 'Connecter la boutique'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
            >
              Retour au tableau de bord
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default ConnectShopify;
